import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "./apiSlice";
import { setupListeners } from "@reduxjs/toolkit/query";
import authReducer from "./authSlice";
import Cookies from "js-cookie";
import {
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import { CookieStorage } from "redux-persist-cookie-storage";

const userInfo = Cookies.get("userInfo")
  ? JSON.parse(Cookies.get("userInfo"))
  : null;
console.log("userInfo in store, ", userInfo);
const initialState = {
  userSignIn: { userInfo },
};

const reducers = combineReducers({
  userSignIn: authReducer,
  [apiSlice.reducerPath]: apiSlice.reducer,
});
const persistConfig = {
  key: "root",
  storage: new CookieStorage(Cookies, {
    expiration: {
      default: 24 * 60 * 60 * 1000, // Cookies expire after one 1hr
    },
  }),
  blacklist: [apiSlice.reducerPath],
};
const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
  reducer: persistedReducer,

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(apiSlice.middleware),
});
console.log({ store, initialState });
setupListeners(store.dispatch);
